import DataTableText_vue_vue_type_script_setup_true_lang_default from "./DataTableText.vue.script.js";
//#region src/v2/components/data-table/DataTableText.vue
var DataTableText_default = DataTableText_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { DataTableText_default as default };

//# sourceMappingURL=DataTableText.vue.js.map